import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const modes = [
  { id: "regular", title: "Kerja Reguler", detail: "Mulai kerja harian." },
  { id: "overtime", title: "Lembur", detail: "Mulai sesi lembur terpisah." },
  { id: "review", title: "Review Pekerjaan", detail: "Akses baca saja maksimal 15 menit." },
];

export default function ActivityStart() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("");
  const [plannedEnd, setPlannedEnd] = useState("");
  const [description, setDescription] = useState("");
  const [active, setActive] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function refresh() {
    try {
      const r = await api.get("/activity/me");
      setActive(r.data?.activity || null);
    } catch (e) {
      setError(e.response?.data?.detail || "Gagal memuat aktivitas.");
    }
  }

  useEffect(() => { refresh(); }, []);

  async function start() {
    setBusy(true);
    setError("");
    try {
      await api.post("/activity/start", {
        mode,
        planned_end: mode === "review" ? null : plannedEnd,
        work_description: mode === "review" ? "" : description,
      });
      navigate("/dashboard", { replace: true });
    } catch (e) {
      setError(e.response?.data?.detail || "Gagal memulai aktivitas.");
      await refresh();
    } finally {
      setBusy(false);
    }
  }

  async function finish() {
    setBusy(true);
    setError("");
    try {
      await api.post("/activity/finish");
      setActive(null);
      navigate("/login", { replace: true });
    } catch (e) {
      setError(e.response?.data?.detail || "Gagal mengakhiri sesi.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="mx-auto max-w-2xl space-y-5 p-6">
      <div data-workspace-redundant-header>
        <h1 className="text-2xl font-bold">Aktivitas Karyawan</h1>
        <p className="text-sm text-muted-foreground">Pilih aktivitas sebelum melanjutkan.</p>
      </div>
      {error && <div role="alert" className="rounded-lg border border-red-300 p-3">{error}</div>}

      {active ? (
        <section className="space-y-3 rounded-xl border p-4">
          <h2 className="font-semibold">Sesi aktif: {modes.find(x => x.id === active.mode)?.title || active.mode}</h2>
          <p className="text-sm">Mulai: {active.started_at}</p>
          <button className="rounded-lg border px-4 py-2" disabled={busy} onClick={finish}>
            Akhiri sesi
          </button>
        </section>
      ) : (
        <>
          <section className="grid gap-3 sm:grid-cols-3">
            {modes.map(item => (
              <button key={item.id} type="button" onClick={() => setMode(item.id)}
                className={`rounded-xl border p-4 text-left ${mode === item.id ? "border-primary ring-2 ring-primary" : ""}`}>
                <span className="block font-semibold">{item.title}</span>
                <span className="mt-2 block text-sm text-muted-foreground">{item.detail}</span>
              </button>
            ))}
          </section>

          {mode && mode !== "review" && (
            <section className="space-y-3 rounded-xl border p-4">
              <label className="block text-sm font-medium">
                Rencana jam pulang
                <input className="mt-1 block w-full rounded-md border p-2" type="datetime-local"
                  value={plannedEnd} onChange={e => setPlannedEnd(e.target.value)} />
              </label>
              <label className="block text-sm font-medium">
                Deskripsi pekerjaan
                <textarea
                  className="mt-1 block w-full rounded-md border p-2"
                  rows={3}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </label>
            </section>
          )}

          <button
            type="button"
            disabled={!mode || busy || (mode !== "review" && (!plannedEnd || !description.trim()))}
            onClick={start}
            className="rounded-lg bg-primary px-5 py-3 font-semibold text-primary-foreground disabled:opacity-50"
          >
            {busy ? "Memproses..." : "Mulai aktivitas"}
          </button>
        </>
      )}
    </main>
  );
}
